// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rgSt","col":"styles_col__1aGkT"};